
import {CmonRequestServiceResponseData} from '../CmonRequestService';
import CmonError from './CmonError';

export default class CmonRedirectError
    extends CmonError {

    constructor(jsonError: CmonRequestServiceResponseData) {
        super(jsonError);
    }

}
